import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_0361f5ae";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_0361f5ae" };
/** script content **/
require("./cascade-picker-modal.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex0361f5ae%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fcascade-picker-modal%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_0361f5ae"],
    ctorType: "component",
    outputPath: "components/index0361f5ae/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-picker-modal-base': getComponent(require("../picker-modal/picker-modal-base.mpx?isComponent&outputPath=components%2Fpicker-modal-base6c849b9a%2Findex")), 'cube-cascade-picker': getComponent(require("../cascade-picker/index.mpx?isComponent&outputPath=components%2Findexb6a89be4%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
